import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'react-i18next';

class CompanySubHeader extends React.Component {
  static propTypes = {
    title: PropTypes.string
  };

  render() {
    return (
      <div className="m-subheader ">
        <div className="d-flex align-items-center">
          <div className="mr-auto">
            <h3 className="m-subheader__title ">
              <Trans>{this.props.title}</Trans>
            </h3>
          </div>
        </div>
      </div>
    );
  }
}

export default CompanySubHeader;
